// WCC Projects > Change of Routine
// src > ts > app.ts
// Created 22 February 2021, Updated 1 February 2023 (Version 2.1.6)

// MODULES

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

// CONSTANTS

const firebaseConfig = {
  apiKey: "AIzaSyDkCwu_xSAfKzFCUN4YcHdyTfDcLM0KwJc",
  authDomain: "change-of-routine.wccprojects.com",
  projectId: "cmw-admin-forms",
  storageBucket: "cmw-admin-forms.appspot.com",
  messagingSenderId: "1059559327230",
  appId: "1:1059559327230:web:3dfbe9def03c8675d36caf"
};

export const authentication = firebase.auth;
export const database = firebase.firestore;
export const storage = firebase.storage;

// FUNCTIONS

const initializeApp = () => {
  firebase.initializeApp(firebaseConfig);
};

// INITIAL SCRIPTS

initializeApp();
